// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__pXEFJ","childContainer":"About_childContainer__H7r+z","backButton":"About_backButton__G1iqs"};